import { Dialog, DialogContent, DialogTitle, IconButton, Slide, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { BaseBTN } from "src/components/ui";
import CloseIcon from "src/components/ui/svgIcon/CloseIcon";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SelectRealLegalDialog = ({ openRealLegal, onCloseRealLegal }) => {
  const navigate = useNavigate();
  return (
    <Dialog
      maxWidth="sm"
      sx={{
        textAlign: "center",
        margin: "0 auto",
      }}
      open={openRealLegal}
      TransitionComponent={Transition}
      keepMounted
      onClose={onCloseRealLegal}
    >
      <DialogTitle textAlign="center" variant="h6">
        عنوان
        {onCloseRealLegal ? (
          <IconButton
            aria-label="close"
            onClick={onCloseRealLegal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" color="text.tertiary" pt={2}>
          هویت کاربری خود را انتخاب کنید.
        </Typography>
        <Stack m={3} direction="row" spacing={1.5} justifyContent="center" alignItems="center">
          <BaseBTN onClick={() => navigate("/register-real")} variant="outlined" sx={{ width: "195px" }}>
            حقیقی
          </BaseBTN>
          <BaseBTN onClick={() => navigate("/register-legal")} variant="outlined" sx={{ width: "195px" }}>
            حقوقی
          </BaseBTN>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SelectRealLegalDialog;
